<div *ngIf="model">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ model.useTranslation ? (model.title | translate) : model.title }}
    </h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="negative()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="box box-primary">
      <div class="row">
        <div class="col col-lg-12">
          <p [innerHtml]="model.useTranslation ? (model.description | translate) : model.description"></p>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-end">
    <button id="negative-modal-button" class="btn btn-default" (click)="negative()">
      {{ model.useTranslation ? (model.negativeButtonText | translate) : model.negativeButtonText }}
    </button>
    <button id="positive-modal-button" class="btn btn-default" (click)="positive()">
      {{ model.useTranslation ? (model.positiveButtonText | translate) : model.positiveButtonText }}
    </button>
  </div>
</div>